import { render, staticRenderFns } from "./Idea2.vue?vue&type=template&id=b6dc313a"
import script from "./Idea2.vue?vue&type=script&lang=js"
export * from "./Idea2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports